import "./ToggleDrawingTab.css";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";

// Define a mapping of roles to allowed tabs
const ROLE_TABS_MAP = {
  ADMIN: ["SALES", "COORDINATION", "IFC", "HVAC"],
  MANAGE: ["SALES", "COORDINATION", "IFC", "HVAC"],
  SITE: ["COORDINATION", "IFC", "HVAC"],
};

const TAB_LABELS = {
  SALES: "SALES",
  COORDINATION: "COORDINATION",
  IFC: "IFC",
  HVAC: "HVAC",
  DESIGN: "DESIGN",
};

const ToggleDrawingTab = ({
  currentUserRole,
  selectedTab,
  handleTabChange,
}) => {
  const allowedTabs =
    ROLE_TABS_MAP[currentUserRole] ||
    ROLE_TABS_MAP[
      Object.keys(ROLE_TABS_MAP).find((role) =>
        currentUserRole?.startsWith(role),
      )
    ] ||
    [];

  if (allowedTabs.length === 0) return null;

  return (
    <div className="ToggleDrawingTab__container">
      <ToggleButtonGroup
        color="primary"
        value={selectedTab}
        exclusive
        onChange={handleTabChange}
        aria-label="Area-Drawings"
        className="ToggleDrawingTab__buttongroup"
      >
        {allowedTabs.map((tab) => (
          <ToggleButton
            key={tab}
            value={tab}
            disabled={selectedTab === tab}
            id="ToggleDrawingTab__button"
          >
            {TAB_LABELS[tab] || tab}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default ToggleDrawingTab;
